// const CryptoJS = require('crypto-js')  // 引用AES源码js
import CryptoJS from 'crypto-js'
// const key = CryptoJS.enc.Utf8.parse(str2hex(FormatDate(new Date(), 'MMhhddmm'), 8))
const key = CryptoJS.enc.Utf8.parse('086B800718D781EE') // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('56ADEF12FA38E1C2')   // 十六位十六进制数作为密钥偏移量

// 解密方法
export function Decrypt(word) {
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr
}

// 加密方法
export function Encrypt(word) {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  return CryptoJS.AES.encrypt(srcs, key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

// // 字符串转16进制
// function str2hex(str, length) {
//   if (str === '') {
//     return ''
//   }
//   var arr = []
//   // arr.push('0x')
//   for (var i = 0; i < (length || str.length); i++) {
//     arr.push(str.charCodeAt(i).toString(16))
//   }
//   return arr.join('').toUpperCase()
// }

// function FormatDate (date, fmt) { // author: meizz
//   var o = {
//     'M+': date.getMonth() + 1, // 月份
//     'd+': date.getDate(), // 日
//     'h+': date.getHours(), // 小时
//     'm+': date.getMinutes(), // 分
//     's+': date.getSeconds(), // 秒
//     'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
//     'S': date.getMilliseconds() // 毫秒
//   }
//   if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
//   for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
//   return fmt
// }



// WEBPACK FOOTER //
// ./src/common/js/secret.js